<template>
    <div class="main" v-if="loading === 1">
      <div class="head">
        <div>
          <h1 style="margin:0;">주문결제</h1>
          <hr>
        </div>
      </div>
      <div class="body">
        <div class="orderInfoDiv">
          <h3>1. 배송지 정보</h3>
          <div v-if="!$empty($store.state.addressList)" class="orderInfo-list">
            <select class="selectAddress" v-model="selectAddress">
              <option value="">주소를 선택해 주세요.</option>
              <option v-for="(row, index) in $store.state.addressList" :key="index" :value="row">{{row.RECEIVE_NAME}}</option>
            </select>
            <button class="list-delete-btn" @click="preupdateAddr" v-if="!$empty(selectAddress)">수정</button>
            <button class="list-delete-btn" @click="preDeleteAddr" v-if="!$empty(selectAddress)">삭제</button>
          </div>
          <div v-if="!$empty($store.state.addressList)" style="margin: 5px 0px 5px 0px;">
            <button @click="searchAddrOpen" class="reg-addr">배송지등록</button>
          </div>
        </div>
        <div class="orderInfoDiv" v-if="$empty($store.state.addressList)">
          <h4>등록된 배송지가 없습니다.</h4>
          <button @click="searchAddrOpen" class="reg-addr">배송지등록</button>
        </div>
        <div class="orderInfoDiv"
        v-else-if="!$empty(selectAddress)"
        style="border-radius: 4px;
        border: 1px solid $e0e0e0;
        box-sizing:border-box;
        padding: 8px;
        font-size: 14px;">
          <div>
            받으시는분: {{returnMergeAddress('name')}}
          </div>
          <div>
            주소: {{returnMergeAddress('addr')}}
          </div>
          <div>
            전화번호: {{returnMergeAddress('phone1')}}
          </div>
          <div>
            부재시 전화번호: {{returnMergeAddress('phone2')}}
          </div>
        </div>
        <hr>
        <div class="orderInfoDiv">
          <h3>2. 상품정보</h3>
        </div>
        <div class="orderInfoDiv">
          <div v-for="(seq, index1) in storeSeqList" :key="index1" class="productByStore">
            <h4>{{returnStoreName(seq)}}</h4>
            <div v-for="(row, index2) in selectProduct" :key="index2">
              <div v-if="row.store_seq === seq || row.storeSeq === seq" class="productDiv">
                <label :for="`productChk${index2}`"></label>
                <div class="productImgDiv">
                  <div style="margin:auto;">
                    <img :src="row.imageUrl" class="productImg" v-if="!$empty(row.imageUrl)">
                    <img :src="row.image_url" class="productImg" v-else-if="!$empty(row.image_url)">
                    <img :src="row.IMAGE_URL" class="productImg" v-else>
                  </div>
                </div>
                <div class="productContent">
                  <div class="nameDiv">
                    <!-- 상품명 -->
                    {{row.name}}
                  </div>
                  <div class="eventDayDiv" style="margin:0;">
                    <!-- 할인률 및 행사기간-->
                    <div style="flex:1;" v-if="row.cost_price > 0 && row.cost_price > row.sell_price">
                      <span style="color:#FE9400;">
                        {{ Math.round((1 - (row.sell_price / row.cost_price)) * 100) + '%할인 행사상품' }}
                      </span>
                    </div>
                  </div>
                  <div class="eventDayDiv" style="margin:0;">
                    <div style="flex:1;">
                      <span style="color:#2d2d2d;font-size:20px;font-weight:500;">
                        {{numberWithCommas(row.sell_price * row.order_qty)}}
                      </span>
                    </div>
                  </div>
                  <div class="storeNameDiv">
                    <!-- 매장명 -->
                    <span style="font-size: 14px;color:#a1a1a1;">
                      {{returnStoreName(row.storeSeq)}}
                    </span>
                  </div>
                  <div class="quantityDiv">
                    <!-- 수량조절 및 정상가, 판매가 -->
                    <div style="flex:3;display:flex;">
                      <!-- 주문수량: <input type="number" class="quantityInput" v-model="row.order_qty" readonly> -->
                      주문수량: {{ row.order_qty }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="productDiv"
          v-if="deliveryCost !== 0"
          style="border:0;color:rgb(254, 148, 0);font-weight:bolder;height:auto;text-align:right;align-items: center;justify-content: flex-end;margin: 10px 0px;">
            배달료: {{numberWithCommas(deliveryCost)}}
          </div>
          <hr style="border:1px solid #e4e4e4;">
        </div>
        <div class="orderInfoDiv">
          <h3>3. 결제정보</h3>
        </div>
        <div class="orderInfoDiv">
          <!-- <div style="width:100%; margin:10px 0px;">
            <input type="radio" name="pay" id="onlinePay" value="1" v-model="payValue">
            <label for="onlinePay">
              <span class="payRadioSelect" :class="{'payRadioNotSelect': payValue !== '1'}">
                신용카드결제
              </span>
            </label>
          </div> -->
          <div style="width:100%; margin:10px 0px;">
            <input type="radio" name="pay" id="offlineCard" value="5" v-model="payValue">
            <label for="offlineCard">
              <span class="payRadioSelect" :class="{'payRadioNotSelect': payValue !== '5'}">
                만나서결제(카드)
              </span>
            </label>
          </div>
          <div style="width:100%; margin:10px 0px;">
            <input type="radio" name="pay" id="offlineCash" value="6" v-model="payValue">
            <label for="offlineCash">
              <span class="payRadioSelect" :class="{'payRadioNotSelect': payValue !== '6'}">
                만나서결제(현금)
              </span>
            </label>
          </div>
        </div>
        <hr>
      </div>
      <div class="body">
      </div>
      <div class="foot-bar" v-if="allCheck || selectProduct.length > 0">
        <div class="footDetail" style="flex:4;">
          <span style="font-size:1rem;">
            총 결제금액 :
          </span>
          <span style="font-size:1.4rem;">
            &nbsp;{{numberWithCommas(getTotal())}}
          </span>
        </div>
        <div class="footDetail" style="flex:3;">
          <button class="preOrderBtn" id="preOrderBtn" @click="$modal.show('preExeOrder')">바로주문</button>
        </div>
        <form ref="payment" id="payment" name="payment" method="post">
            <input type="hidden" name="SERVICE_ID" value="M2133767">
            <!-- <input type="hidden" name="SERVICE_ID" value="glx_web"> -->
            <input type="hidden" name="AMOUNT">
            <input type="hidden" name="ORDER_ID">
            <input type="hidden" name="ORDER_DATE">
            <input type="hidden" name="ITEM_NAME">
            <input type="hidden" name="ITEM_CODE">
            <input type="hidden" name="USER_ID">
            <input type="hidden" name="USER_NAME">
            <input type="hidden" name="RETURN_URL">
            <input type="hidden" name="QUOTA" value="1">
            <input type="hidden" name="RESERVED1">
            <input type="hidden" name="RESERVED2">
            <input type="hidden" name="RESERVED3">
        </form>
      </div>
      <modal name="processOrder" :width="'99%'" :height="400" :styles="'background: rgba(255, 255, 255, 0);'">
        <div class="processOrder-main">
          <div>
            <img src="@/assets/logo/tery.svg" alt="">
          </div>
          <div>
            <h2 style="color:#ffffff;">잠시만 기다려주세요.</h2>
          </div>
        </div>
      </modal>
      <modal name="preAddressDelete" :width="'80%'" :height="150" :clickToClose="false">
        <div class="preExeOrder-main">
          <div class="preExeOrder-top">
            <span class="preExeOrder-title" style="color:#6d6d6d;font-size: 16px;">
              {{`등록된 주소 ${selectDeleteAddress.RECEIVE_NAME}\n`}}
            </span>
            <br>
            <span class="preExeOrder-title">
              삭제하시겠습니까?
            </span>
          </div>
          <div class="preExeOrder-bot">
            <button
            class="preExeOrder-cancel-btn"
            @click="[selectDeleteAddress = {}, $modal.hide('preAddressDelete')]">취소</button>
            <button
            class="preExeOrder-ok-btn"
            @click="exeDeleteAddr">삭제</button>
          </div>
        </div>
      </modal>
      <modal name="preExeOrder" :width="'80%'" :height="150" :clickToClose="false">
        <div class="preExeOrder-main">
          <div class="preExeOrder-top">
            <span class="preExeOrder-title">
              주문하시겠습니까?
            </span>
          </div>
          <div class="preExeOrder-bot">
            <button
            class="preExeOrder-cancel-btn"
            @click="$modal.hide('preExeOrder')">취소</button>
            <button
            class="preExeOrder-ok-btn"
            @click="preExeOrder">주문</button>
          </div>
        </div>
      </modal>
    </div>
    <div class="main" style="text-align:center;" v-else>
      <img src="@/assets/cart.png" class="blankCart">
      <div>
        <span style="color:#878787;margin:0px 0px 0px 0px;">주문결제에</span><br>
      </div>
      <div>
        <span style="color:#878787;margin:0px 0px 0px 0px;"> 담긴상품이 없습니다.</span>
      </div>
      <div>
        <button @click="goHome" class="goHome">홈으로 가기</button>
      </div>
    </div>
</template>
<script>
// import * as queries from '@/graphql/queries'
import * as mutations from '@/graphql/mutations'
import { API, graphqlOperation } from 'aws-amplify'
import { components } from 'aws-amplify-vue'
import empty from 'is-empty'
import axios from 'axios'
export default {
  name: 'prePay',
  components: {
    components
  },
  created () {
    console.log('asdf')
    this.$store.state.storeDeliveryInfo = this.$cookies.get('storeDeliveryInfo')
    console.log('asdf:::', this.$store.state.storeDeliveryInfo)
  },
  data () {
    return {
      data: [],
      storeSeqList: [],
      storeInfoList: [],
      selectProduct: [],
      addressList: [],
      loading: 1,
      allCheck: false,
      selectAddress: '',
      payValue: '5',
      uuid: '',
      deliveryCost: 0,
      selectDeleteAddress: {}
    }
  },
  mounted () {
    console.log('mounted::', this.$options.name)
    this.$store.state.storeDeliveryInfo = this.$cookies.get('storeDeliveryInfo')
    this.selectProduct = this.$_.cloneDeep(this.$store.state.prePay)
    this.storeSeqList = this.$_.cloneDeep(this.$store.state.storeSeqList)
    this.storeInfoList = this.$_.cloneDeep(this.$store.state.storeInfoList)
    this.getAddress()
    this.loading = 1
    this.getUUID()
  },
  methods: {
    searchAddrOpen () {
      var cookies = this.$cookies.get('kakaoLogin')
      if (!this.$empty(cookies)) {
        this.$axios({
          method: 'get',
          url: `${process.env.API}/chkJoin/key/${cookies.id}`
        })
          .then((response) => {
            if (response.data[0].cnt !== 0) {
              this.$modal.show('searchAddr')
            } else {
              this.$modal.show('certify')
            }
          })
      }
    },
    getTotal () {
      var result = 0
      // var index = this.$store.state.storeDeliveryInfo.findIndex(x => x.STORE_SEQ === this.$store.state.storeSeq)
      console.log('info:::', this.$store.state.storeDeliveryInfo)
      if (!this.$empty(this.selectProduct)) {
        this.selectProduct.forEach(data => {
          result += (data.sell_price * data.order_qty)
        })
        if (result < this.$store.state.storeDeliveryInfo.MIN_PROMO_COST) {
          this.deliveryCost = Number(this.$store.state.storeDeliveryInfo.DELIVERY_COST)
          return result + Number(this.$store.state.storeDeliveryInfo.DELIVERY_COST)
        } else {
          this.deliveryCost = 0
          return result
        }
      } else {
        return result
      }
    },
    getAddress () {
      var userData = this.$cookies.get('userData')
      if (!this.$empty(userData)) {
        this.$axios({
          method: 'get',
          url: `${process.env.API}/getAddress/id/${userData.USER_SEQ}`
        })
          .then((response) => {
            if (response.data !== 'empty') {
              this.$nextTick(() => {
                this.$store.state.addressList = this.$_.cloneDeep(response.data)
              })
            }
          })
      } else {
        console.log('최초가입')
      }
    },
    preupdateAddr () {
      this.$store.commit('setUpdateAddrFlag', 1)
      this.$store.commit('getUpdateAddrData', this.selectAddress)
      this.selectAddress = {}
      this.$modal.show('searchAddr')
    },
    preDeleteAddr () {
      this.selectDeleteAddress = this.$_.cloneDeep(this.selectAddress)
      this.$modal.show('preAddressDelete')
    },
    exeDeleteAddr () {
      this.selectAddress = ''
      const vm = this
      this.$axios({
        method: 'patch',
        url: `${process.env.API}/deleteAddress/${this.selectDeleteAddress.DELIVERY_SEQ}`
      })
        .then((response) => {
          if (response.data === 'success') {
            vm.$modal.hide('preAddressDelete')
            vm.selectAddress = ''
            vm.$store.commit('deleteAddress', vm.selectDeleteAddress)
            vm.selectDeleteAddress = {}
          }
        })
    },
    preExeOrder () {
      this.$modal.hide('preExeOrder')
      if (this.$empty(this.selectAddress)) {
        alert('주소지를 선택해 주세요')
      } else if (this.$empty(this.payValue)) {
        alert('결제정보를 입력해 주세요')
      } else {
        this.$modal.hide('preExeOrder')
        if (this.payValue === '1') {
          this.exeCardOrder()
        } else {
          this.exeOrder()
        }
      }
    },
    exeCardOrder () {
      // this.$store.state.isLoading = true
      this.$store.state.isLoading = true
      var now = this.$dayjs().unix()
      var totalValue = this.getTotal()
      var orderSeq = `${now}-${this.getUUID()}`
      var orderNo = `${this.$cookies.get('storeSeq')}-${now}`
      this.$cookies.set('orderSeq', orderSeq)
      this.$cookies.set('orderNo', orderNo)
      const payment = document.getElementById('payment')
      // 결제금액
      payment.children[1].value = totalValue
      // 주문번호
      payment.children[2].value = orderSeq
      // 주문일시
      payment.children[3].value = this.$dayjs().format('YYYYMMDDHHmmss')
      // 상품명
      payment.children[4].value = `${this.selectProduct.length > 1 ? `${this.selectProduct[0].name} 외 ${this.selectProduct.length - 1} 건` : `${this.selectProduct[0].name}`}`
      // 상품코드
      payment.children[5].value = `P0001`
      // 고객 아이디
      // payment.children[6].value = `${this.$store.state.userData.KAKAO_AUTH}`
      payment.children[6].value = `A1924214`
      // 고객명
      payment.children[7].value = !this.$empty(this.$store.state.userData.USER_NAME) ? this.$store.state.userData.USER_NAME : this.$store.state.userData.USER_PHONE.substr(7, 4)
      // return url
      // payment.children[8].value = 'http://192.168.0.2:9090/paymentCardReturnWeb'
      payment.children[8].value = 'https://sery.co.kr/paymentCardReturn'
      // 변수1
      payment.children[9].value = `${this.$cookies.get('storeSeq')}`
      // 변수2
      payment.children[10].value = ''
      // 변수3
      payment.children[11].value = ''
      payment.target = 'payment'
      // payment.action = `https://pay.billgate.net/credit/smartphone/IspOrderRegi.jsp`
      payment.action = this.$cookies.get('device') === 'pc' ? `https://pay.billgate.net/credit/certify.jsp` : `https://pay.billgate.net/credit/smartphone/certify.jsp`
      // payment.action = 'http://tpay.billgate.net/credit/certify.jsp'
      this.$cookies.set('payFlag', 'pay', '3MIN')
      var option = 'width=520,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,left=150,top=150'
      window.open('', '_self', option)
      if (/edge/.test(navigator.userAgent.toLowerCase()) || /MSIE/.test(navigator.userAgent) || /Trident.*rv[ :]*11\./.test(navigator.userAgent)) {
        var befCharset = document.charset
        document.charset = 'euc-kr'
        payment.submit()
        document.charset = befCharset
        this.chkPay()
      } else {
        payment.acceptCharset = 'euc-kr'
        payment.submit()
        this.chkPay()
      }
    },
    chkPay () {
      var timer = ''
      var sec = 0
      var result = ''
      var orderSeq = this.$cookies.get('orderSeq')
      var payFlag = this.$cookies.get('payFlag')
      const vm = this
      start()
      function call () {
        sec++
        if (sec === 100) {
          console.log('stop')
          stop()
        }
        console.log('sec:::', sec)
        if (!empty(payFlag) && payFlag === 'pay' && !empty(orderSeq)) {
          axios({
            method: 'get',
            url: `${process.env.API}/chkPayComplete`,
            params: {
              seq: orderSeq
            }
          })
            .then((response) => {
              result = response.data
              console.log('result:::', result)
              if (result === 'success') {
                stop()
                vm.exeOrder()
              } else {
                console.log('!!')
              }
            })
        }
      }
      function start () {
        timer = setInterval(call, 3000)
      }
      function stop () {
        clearInterval(timer)
      }
    },
    async exeOrder () {
      this.$store.state.isLoading = true
      const vm = this
      var now = this.$dayjs().unix()
      var uuid = `${!this.$empty(this.$cookies.get('orderSeq')) ? `${this.$cookies.get('orderSeq')}` : `${now}-${this.getUUID()}`}`
      var data = []
      // ex) 051_00000008-123789123 (storeSeq + this.$dayjs().unix())
      var orderNo = `${!this.$empty(this.$cookies.get('orderNo')) ? this.$cookies.get('orderNo') : `${this.$cookies.get('storeSeq')}-${now}`}`
      var address = this.$_.cloneDeep(this.selectAddress)
      var product = this.$_.cloneDeep(this.selectProduct)
      var storeSeq = this.$cookies.get('storeSeq')
      var storeName = this.returnStoreName(this.$cookies.get('storeSeq'))
      var userName = this.returnMergeAddress('name')
      var paymentType = this.payValue
      var productBasket = JSON.parse(localStorage.getItem(this.$cookies.get('storeSeq')))
      var delivery = {
        deliverySeq: address.DELIVER_SEQ,
        failCode: '',
        receiveAddress: address.RECEIVE_ADDRESS,
        receiveAddressDetail: address.RECEIVE_ADDRESS_DETAIL,
        receiveName: address.RECEIVE_NAME,
        receivePhone1: address.RECEIVE_PHONE1,
        receivePhone2: address.RECEIVE_PHONE2,
        regDate: address.REG_DATE,
        result: '',
        useFlag: address.USE_FLAG,
        userSeq: address.USER_SEQ
      }
      var work1 = await preWork()
      if (!this.$empty(work1)) {
        var obj = {
          orderSeq: `${uuid}`,
          storeSeq: `${this.$cookies.get('storeSeq')}`,
          userSeq: this.$store.state.userData.USER_SEQ,
          deliveryInfo: JSON.stringify(delivery),
          orderDate: this.$dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
          paymentType: Number(this.payValue),
          deliveryType: 1,
          memo: '',
          orderPrice: this.getTotal(),
          deliveryPrice: this.deliveryCost,
          orderState: 1,
          deliveryName: '',
          deliveryCode: 0,
          deliveryNo: '',
          receiveCode: '',
          detailInfo: work1,
          storeName: this.$store.state.storeInfo.STORE_NAME,
          userName: userName,
          minPromoCost: this.$store.state.storeDeliveryInfo.MIN_PROMO_COST,
          cancelReason: '',
          cancelReasonDetail: ''
        }
        console.log('obj:::', obj)
        data.push(obj)
        var order = await API.graphql(
          graphqlOperation(mutations.createSeryOrderInfo, {
            input: obj
          })
        )
        if (!this.$empty(order)) {
          console.log('order::::', order)
          localStorage.removeItem(this.$cookies.get('storeSeq'))
          localStorage.setItem(this.$cookies.get('storeSeq'), JSON.stringify(productBasket))
          this.selectProduct = []
          obj.orderNo = orderNo
          var updateObj = {
            orderSeq: obj.orderSeq,
            storeSeq: obj.storeSeq,
            userSeq: obj.userSeq,
            deliveryInfo: obj.deliveryInfo,
            orderDate: obj.orderDate,
            paymentType: obj.paymentType,
            deliveryType: obj.deliveryType,
            memo: obj.memo,
            orderNo: obj.orderNo,
            orderPrice: obj.orderPrice,
            deliveryPrice: obj.deliveryPrice,
            orderState: obj.orderState,
            deliveryName: obj.deliveryName,
            deliveryCode: obj.deliveryCode,
            deliveryNo: obj.deliveryNo,
            receiveCode: obj.receiveCode,
            bookingTime: obj.bookingTime,
            detailInfo: obj.detailInfo,
            deliveryTime: obj.deliveryTime,
            doneTime: obj.doneTime,
            riderId: obj.riderId,
            cancelReason: obj.cancelReason,
            // storeName: obj.storeName,
            cancelReasonDetail: obj.cancelReasonDetail
          }
          console.log('updateObj:::', updateObj)
          var update = await API.graphql(graphqlOperation(
            mutations.updateSeryOrderInfo, {
              input: updateObj
            })
          )
          console.log('success input order:::', update)
          this.$store.commit('getBasketCnt', JSON.stringify(productBasket))
          var push = await sendPush()
          if (push.status === 200) {
            var sendTele = await sendTelegram()
            if (sendTele === 'success') {
              this.$store.state.isLoading = false
              alert('주문이 접수되었습니다.')
              this.$router.push('orderProcessList')
            } else {
              console.log('pushData:::', push)
              this.$store.state.isLoading = false
              alert('주문이 접수되었습니다.')
              this.$router.push('orderProcessList')
            }
          } else {
            console.log('sendTele err:::', sendTele)
            var push2 = await sendPush()
            if (push2.status === 200) {
              this.$store.state.isLoading = false
              alert('주문이 접수되었습니다.')
              this.$router.push('orderProcessList')
            } else {
              console.log('pushData err:::', push2)
              this.$store.state.isLoading = false
              alert('주문이 접수되었습니다.')
              this.$router.push('orderProcessList')
            }
          }
        }
      } else {
        this.$store.state.isLoading = false
        alert('err')
      }
      function sendTelegram () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: `https://n18xzda2u4.execute-api.ap-northeast-2.amazonaws.com/prod/new-order`,
            params: {
              storeName: `[WEB]${vm.$store.state.storeInfo.STORE_NAME}`,
              storeSeq: vm.$store.state.storeInfo.STORE_SEQ,
              orderDate: updateObj.orderDate,
              msg: `주문이 접수 되었습니다.|- 주문번호 : ${updateObj.orderNo}|- 주문일시 : ${vm.$dayjs(updateObj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(updateObj.orderPrice)}`
            }
          })
            .then((response) => {
              resolve(response.data)
            })
        })
      }
      function sendPush () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: 'https://www.sery.co.kr/store/v4/' + vm.$store.state.storeInfo.STORE_SEQ + '/orders',
            data: {
              deliveryInfo: {
                failCode: '',
                result: ''
              },
              failCode: '',
              memo: `주문이 접수 되었습니다.|- 주문번호 : ${updateObj.orderNo}|- 주문일시 : ${vm.$dayjs(updateObj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(updateObj.orderPrice)}`,
              orderDetails: [],
              orderNo: updateObj.orderNo,
              result: '',
              storeInfo: {
                endPuter: 10,
                failCode: '',
                heloFriendCount: 0,
                result: '',
                staffCount: 0,
                startPuter: 0,
                storeDelivery: {
                  deliveryCost: 0,
                  minPromoCost: 0
                }
              },
              storeSeq: vm.$store.state.storeInfo.STORE_SEQ
            }
          })
            .then((response) => {
              resolve(response)
            })
        })
      }
      function preWork () {
        return new Promise((resolve, reject) => {
          var data = []
          for (let i = 0; i < product.length; i++) {
            var x = product[i]
            if (!empty(productBasket)) {
              var index = productBasket.findIndex(data => data.barcode === x.barcode)
              if (index !== -1) {
                productBasket.splice(index, 1)
              }
            } else {
              console.log('장바구니에 해당 상품 없음')
            }
            var obj = {
              eventInfo: {
                backgroundUrl: '',
                barcode: x.barcode,
                cancelList: [],
                commentCount: 0,
                costPrice: x.cost_price,
                couponPublishNum: 0,
                deliveryFlag: 1,
                deliveryPrice: null,
                endDate: null,
                endPuter: 30,
                endTime: null,
                event: 0,
                eventList: [],
                eventTotalCount: 0,
                failCode: '',
                goodCount: 0,
                imageItems: [
                  {
                    failCode: '',
                    imageUrl: x.image_url,
                    imageUrlFull: x.image_url,
                    result: ''
                  }
                ],
                imageUrl: x.image_url,
                imageSeq: 0,
                like_list: [],
                likeUp: 0,
                linkSeq: 0,
                memo: x.name,
                name: x.name,
                optionList: [],
                paymentFlag: 3,
                paymentType: Number(paymentType),
                result: '',
                sellPrice: x.sell_price,
                sellingPrice: x.sell_price,
                seq: `${x.barcode}_${storeSeq}`,
                sortDate: null,
                startDate: null,
                startPuter: 0,
                startTime: null,
                storeLogo: x.store,
                storeName: storeName,
                storeSeq: storeSeq,
                tags: [],
                title: x.name,
                uprightFlag: 0
              },
              eventSeq: `${x.barcode}_${storeSeq}`,
              orderQty: `${x.order_qty}`,
              orderSeq: uuid
            }
            data.push(JSON.stringify(obj))
          }
          resolve(data)
        })
      }
    },
    returnEmptyAddress () {
      if (this.$empty(this.selectAddress) && this.$empty(this.$store.state.addressList)) {
        return '배송지를 추가해 주세요'
      } else if (this.$empty(this.selectAddress) && !this.$empty(this.$store.state.addressList)) {
        return '배송지를 선택해 주세요'
      }
    },
    returnMergeAddress (value) {
      if (this.selectAddress !== '') {
        if (value === 'name') {
          return `${this.selectAddress.RECEIVE_NAME}`
        }
        if (value === 'addr') {
          return `${this.selectAddress.RECEIVE_ADDRESS} ${this.selectAddress.RECEIVE_ADDRESS_DETAIL}`
        }
        if (value === 'phone1') {
          return `${this.phoneFormat(this.selectAddress.RECEIVE_PHONE1)}`
        }
        if (value === 'phone2') {
          return `${this.phoneFormat(this.selectAddress.RECEIVE_PHONE2)}`
        }
      }
    },
    returnStoreName (val) {
      var result = this.$_.filter(this.storeInfoList, ['STORE_SEQ', val])
      if (this.$empty(result)) {
        return ''
      } else {
        return result[0].STORE_NAME
      }
    },
    phoneFormat (num) {
      return num.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3')
    },
    numberWithCommas (x) {
      if (!x) {
        return '0원'
      } else if (x === 0 || x === '0') {
        return ''
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
      }
    },
    getUUID () { // UUID v4 generator in JavaScript (RFC4122 compliant)
      var uuid = ''
      var i, random
      for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0
        if (i === 8 || i === 12 || i === 16 || i === 20) {
          uuid += '-'
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16)
      }
      return uuid
    }
  }
}
</script>

<style scoped>
@import url('/css/prePay.css');
</style>



// WEBPACK FOOTER //
// src/components/prePay/prePay.vue